import { Button } from "antd";
import { InternsForEmployerDTO, StudentCVAccessDTO } from "../../../Api";
import { Breakpoint } from "antd/lib";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { brands, solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { downloadFile } from "../../../utils/downloadUtils";
import { downloadStudentCv } from "../../../Requests/academic-user-requests";
import {
	NOTIFICATION_TYPES,
	openNotification,
} from "../../Notifications/NotificationsUtils";

export function useColumns(goToStudentProfile: any) {
	const { t, i18n } = useTranslation();

	const downloadFail = (_err: any) => {
		openNotification(
			t("universityAccord.error"),
			t("universityAccord.downloadError"),
			NOTIFICATION_TYPES.ERROR
		);
	};

	const columns = useMemo(() => {
		return [
			{
				title: t("students.name"),
				dataIndex: "name",
				key: "name",
				render: (_text: string | undefined, record: StudentCVAccessDTO) => {
					return (
						<a
							onClick={() => {
								goToStudentProfile(record.studentId);
							}}
						>
							<b>{record.name}</b>
						</a>
					);
				},
			},
			{
				title: t("students.email"),
				dataIndex: "email",
				key: "email",
				ellipsis: true,
			},
			{
				title: t("students.phone"),
				dataIndex: "phone",
				key: "phone",
			},
			{
				title: t("students.faculty"),
				key: "faculty",
				render: (_text: string | undefined, record: StudentCVAccessDTO) =>
					i18n.language === "en" ? record.facultyNameEn : record.facultyNameRo,
			},
			{
				title: t("students.year"),
				key: "year",
				render: (_text: string | undefined, record: StudentCVAccessDTO) =>
					t("account." + record.year),
			},
			{
				title: (
					<FontAwesomeIcon
						icon={brands("linkedin")}
						style={{ fontSize: "15px" }}
					/>
				),
				dataIndex: "linkedinUrl",
				key: "linkedinUrl",
				render: (
					linkedinUrl: string | undefined,
					_record: StudentCVAccessDTO
				) => {
					if (!linkedinUrl || linkedinUrl === "") {
						return (
							<FontAwesomeIcon
								icon={solid("arrow-right")}
								style={{ fontSize: "15px", opacity: 0.2 }}
								title={t("students.linkedinUrlNotSet")}
							/>
						);
					}

					return (
						<a href={linkedinUrl} target="_blank">
							<FontAwesomeIcon
								icon={solid("arrow-right")}
								style={{ fontSize: "15px" }}
								title={t("students.goToLinkedinUrl")}
							/>
						</a>
					);
				},
			},
			{
				title: t("students.cvUrl"),
				dataIndex: "cvFileName",
				key: "cvFileName",
				render: (_text: string | undefined, record: StudentCVAccessDTO) => {
					if (!record.cvFileName) {
						return (
							<FontAwesomeIcon
								icon={solid("download")}
								style={{ fontSize: "15px", opacity: 0.2 }}
								title={t("students.cvNotSet")}
							/>
						);
					}

					return (
						<Button
							title={"CV"}
							style={{
								backgroundColor: "transparent",
								border: "none",
								outline: "none",
								float: "left",
								padding: "0",
							}}
							onClick={() =>
								downloadFile(
									downloadStudentCv(record.studentId!),
									t("documents.Cv") + "_" + record.name
								).catch(downloadFail)
							}
						>
							<FontAwesomeIcon
								icon={solid("download")}
								style={{ fontSize: "15px" }}
								title={t("students.downloadCv")}
							/>
						</Button>
					);
				},
			},
		].filter(Boolean);
	}, [t]);

	return columns;
}
